module.exports = __webpack_public_path__ + "components/flag/static/square/dk-d07e5c7beff53cce6a2fa49ed43b0148.svg";